angular.module('app') .directive('preventSubmit', function () { 
    return { 
        restrict: 'A',
        link: function(scope, element, attrs, ctrl) { 
            element.on('keydown', function(ev) {
                if(ev.keyCode == 13) {
                    ev.preventDefault();
                }
            });
        } 
    };
});
